export default {
  appTitle: 'LoanKnow - Dev',
  apiUrl: 'https://api.dev.go.uff.pro/api',
  appEnv: 'staging',
  useMockServices: false,
  p2enabled: false,
  googleClientId: '531776166755-vqvlcc4r450gj5l97fflq1tn8s5akhoq.apps.googleusercontent.com',
  microsoftClientId: 'b34f8ab1-ee4d-46cb-b160-fcda3d0bbd72',
  microsoftTenantId: 'common',
};
